const AUTH_STORAGE_KEY = 'crm_auth';
const ORG_STORAGE_KEY = 'crm_current_org';

export interface User {
  id: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  confirmed: boolean;
  isSuperAdmin?: boolean;
}

export interface Organization {
  id: string;
  name: string;
  currency?: string;
  requireConfirmPassword?: boolean;
  googleAnalyticsId?: string | null;
}

export interface AuthState {
  user: User | null;
  organization: Organization | null;
  isAuthenticated: boolean;
}

export function getAuthState(): AuthState {
  const storedAuth = sessionStorage.getItem(AUTH_STORAGE_KEY);
  const storedOrg = sessionStorage.getItem(ORG_STORAGE_KEY);

  if (!storedAuth) {
    return {
      user: null,
      organization: null,
      isAuthenticated: false,
    };
  }

  try {
    const { user } = JSON.parse(storedAuth);
    let organization: Organization | null = null;

    if (storedOrg) {
      organization = JSON.parse(storedOrg);
    }

    return {
      user,
      organization,
      isAuthenticated: !!user,
    };
  } catch {
    return {
      user: null,
      organization: null,
      isAuthenticated: false,
    };
  }
}

export function isAuthenticated(): boolean {
  return getAuthState().isAuthenticated;
}

export function getUser(): User | null {
  return getAuthState().user;
}

export function getOrganization(): Organization | null {
  return getAuthState().organization;
}

export function setAuthState(user: User, organization?: Organization | null): void {
  sessionStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify({ user }));
  if (organization) {
    sessionStorage.setItem(ORG_STORAGE_KEY, JSON.stringify(organization));
  }
}

export function clearAuthState(): void {
  sessionStorage.removeItem(AUTH_STORAGE_KEY);
  sessionStorage.removeItem(ORG_STORAGE_KEY);
}

export function updateUser(updates: Partial<User>): void {
  const storedAuth = sessionStorage.getItem(AUTH_STORAGE_KEY);
  if (storedAuth) {
    const parsed = JSON.parse(storedAuth);
    const updatedUser = { ...parsed.user, ...updates };
    sessionStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify({ ...parsed, user: updatedUser }));
  }
}

export function updateOrganization(updates: Partial<Organization>): void {
  const storedOrg = sessionStorage.getItem(ORG_STORAGE_KEY);
  if (storedOrg) {
    const org = JSON.parse(storedOrg);
    sessionStorage.setItem(ORG_STORAGE_KEY, JSON.stringify({ ...org, ...updates }));
  }
}
